import React from "react";
import Select from "react-select";
import { styles } from "Utils/Common";
import { fullWidthSelectStyles, inputStyles } from "../viewCreateRunHelpers";

type TranslationFn = (value: string) => string;

type TemplateTypeOption = {
  value: string;
  label: string;
};

type CreateRunPanelProps = {
  t: TranslationFn;
  show: boolean;
  isRunTemplatesError: boolean;
  runTemplatesError: any;
  isRunTemplatesLoading: boolean;
  templateTypeOptions: TemplateTypeOption[];
  isCreateRunLoading: boolean;
  newTemplateName: string;
  onTemplateNameChange: (value: string) => void;
  newTemplateType: TemplateTypeOption | null;
  onTemplateTypeChange: (option: TemplateTypeOption | null) => void;
  onCancel: () => void;
  onCreateRun: () => void;
};

const CreateRunPanel: React.FC<CreateRunPanelProps> = ({
  t,
  show,
  isRunTemplatesError,
  runTemplatesError,
  isRunTemplatesLoading,
  templateTypeOptions,
  isCreateRunLoading,
  newTemplateName,
  onTemplateNameChange,
  newTemplateType,
  onTemplateTypeChange,
  onCancel,
  onCreateRun,
}) => {
  if (!show) return null;

  return (
    <div
      className="card mb-4 shadow-none"
      style={{
        background: "#FFF8F0",
        border: "1px solid #F3D9B8",
        borderRadius: "10px",
      }}
    >
      <div className="card-body py-4 px-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6
            className="mb-0 fw-bold"
            style={{ fontSize: "16px", color: "#3F4254" }}
          >
            {t("Add New Plate")}
          </h6>
          <div className="d-flex align-items-center gap-2 gap-lg-3">
            <button
              id="IDViewCreateRunAddPlateCancel"
              type="button"
              className="btn btn-secondary btn-sm btn-secondary--icon fw-500"
              disabled={isCreateRunLoading}
              onClick={onCancel}
            >
              <span>
                <span>{t("cancel")}</span>
              </span>
            </button>
            <button
              id="IDViewCreateRunAddPlateCreateRun"
              type="button"
              className="btn btn-sm btn-primary px-7"
              disabled={isCreateRunLoading}
              onClick={onCreateRun}
            >
              <i style={{ fontSize: "15px" }} className="fa">
                &#xf067;
              </i>
              <span>
                {" "}
                {isCreateRunLoading
                  ? t("Creating...")
                  : t("Create Run")}{" "}
              </span>
            </button>
          </div>
        </div>

        {isRunTemplatesError && (
          <div className="text-danger small mb-3">
            {t(
              runTemplatesError?.response?.data?.message ||
              runTemplatesError?.message ||
              "Unable to load run templates"
            )}
          </div>
        )}

        <div className="row g-3">
          <div className="col-12 col-sm-6 col-md-4">
            <label className="form-label fw-semibold fs-7 mb-1">
              {t("Run Name")}
            </label>
            <input
              id="IDViewCreateRunTemplateName"
              type="text"
              className="form-control bg-white h-38px rounded-2 fs-7"
              style={inputStyles}
              placeholder={t("Template Name")}
              value={newTemplateName}
              disabled={isCreateRunLoading}
              onChange={(e) => onTemplateNameChange(e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4">
            <label className="form-label fw-semibold fs-7 mb-1">
              {t("Template Type")}
            </label>
            <Select
              inputId="IDViewCreateRunTemplateType"
              theme={(theme) => styles(theme)}
              options={templateTypeOptions}
              styles={fullWidthSelectStyles}
              menuPortalTarget={document.body}
              placeholder={
                isRunTemplatesLoading
                  ? t("Loading...")
                  : t("-- Select --")
              }
              isSearchable
              isClearable
              isLoading={isRunTemplatesLoading}
              isDisabled={
                isCreateRunLoading ||
                (isRunTemplatesLoading &&
                  templateTypeOptions.length === 0)
              }
              value={newTemplateType}
              onChange={(opt: any) => onTemplateTypeChange(opt)}
              noOptionsMessage={() =>
                isRunTemplatesError
                  ? t("Unable to load templates")
                  : t("No options")
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateRunPanel;
